import React from "react";
import { Modal } from "react-bootstrap";

import moment from "moment";

const DriverLicense = ({ data, show, hideModal }) => {
	return (
		<Modal show={show} onHide={hideModal} dialogClassName="modal-m modal-dialog modal-text">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Thông tin giấy phép lái xe</h5>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-text-body">
					<div className="block-content">
						<p className="body-title">Số GPLX</p>
						<p>{data.licenseNumber}</p>
					</div>
					<div className="block-content">
						<p className="body-title">Họ tên</p>
						<p className="uppercase">{data.licenseName}</p>
					</div>
					<div className="block-content">
						<p className="body-title">Hạn giấy phép lái xe</p>
						<p className="uppercase">{data.licenseClass}</p>
					</div>
					<div className="block-content">
						<p className="body-title">Ngày sinh</p>
						<p>{moment(data.dob).format("DD/MM/YYYY")}</p>
					</div>
					{data?.papers?.length > 0 && data?.papers[0]?.photos?.length > 0 && (
						<div className="block-content">
							<p className="body-title">Hình ảnh giấy phép lái xe</p>
							<div className="fix-img" style={{ paddingBottom: "63%" }}>
								<img loading="lazy" src={data.papers[0].photos[data.papers[0].photos.length - 1].url} />
							</div>
						</div>
					)}
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default DriverLicense;
